import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo } from 'react';

import { APP_SETTINGS } from '../../../app-settings';

import './icon-sport.scss';

function IconSportUI({ className, sportKey, size, isActive }) {
  return (
    <svg
      className={clsx(
        className,
        'sb-SportIcon',
        isActive && 'isActive',
        `sb-Sport-${sportKey}`,
        APP_SETTINGS.IS_SPORT_ICONS_COLORED && 'isColored'
      )}
      height={size}
      viewBox="0 0 512 512"
      width={size}>
      <use href={`#${sportKey}`} />
    </svg>
  );
}

IconSportUI.propTypes = {
  className: PropTypes.string,
  sportKey: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  size: PropTypes.number,
};

IconSportUI.defaultProps = {
  className: undefined,
  isActive: false,
  size: 20,
};

export const IconSport = memo(IconSportUI);
